
export const getUploadedImages = () => {
  try {
    const savedImages = localStorage.getItem('uploadedImages');
    return savedImages ? JSON.parse(savedImages) : [];
  } catch (error) {
    console.error('Error retrieving images from localStorage:', error);
    return [];
  }
};

export const clearUploadedImages = () => {
  localStorage.removeItem('uploadedImages');
};